var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 230,
    height: 43.847,
    viewBox: "0 0 230 43.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.052,
    y1: 1.162,
    x2: 0.496,
    y2: 0.505,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84e0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#e84d15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#e84a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.365,
    stopColor: "#e84531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    stopColor: "#e83e45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.674,
    stopColor: "#e8355a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.838,
    stopColor: "#e7246d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6007e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.124,
    y1: 0.94,
    x2: 0.902,
    y2: 0.005,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.052,
    y1: 1.162,
    x2: 0.496,
    y2: 0.505,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.124,
    y1: 0.94,
    x2: 0.902,
    y2: 0.005,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33165",
    "data-name": "Group 33165",
    transform: "translate(-6102 -1119.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33164",
    "data-name": "Group 33164",
    transform: "translate(6102 1119.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3047",
    "data-name": "Group 3047",
    transform: "translate(177.526 10.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33159",
    "data-name": "Group 33159",
    transform: "translate(0 20.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35327",
    "data-name": "Path 35327",
    d: "M1.476,27.9l1.255,7.38h.221L4.576,27.9H6.2l1.624,7.38h.3L9.373,27.9h1.476l-1.7,8.561H6.938L5.461,29.6,3.985,36.461H1.7L0,27.9Z",
    transform: "translate(0 -27.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35328",
    "data-name": "Path 35328",
    d: "M19.9,32.2c0-2.878.812-4.5,3.469-4.5s3.469,1.624,3.469,4.5c0,2.952-.812,4.354-3.469,4.354S19.9,35.08,19.9,32.2Zm5.535,0c0-2.14-.369-3.247-2.066-3.247-1.624,0-2.066,1.107-2.066,3.247s.369,3.174,2.066,3.174S25.435,34.342,25.435,32.2Z",
    transform: "translate(-5.213 -27.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35329",
    "data-name": "Path 35329",
    d: "M37,33.435v3.026H35.6V27.9h3.247c1.919,0,2.878.812,2.878,2.731a2.637,2.637,0,0,1-1.4,2.509l1.4,3.395h-1.55l-1.255-3.026H37Zm1.845-4.354H37v3.1h1.845a1.378,1.378,0,0,0,1.476-1.55A1.38,1.38,0,0,0,38.847,29.081Z",
    transform: "translate(-9.326 -27.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35330",
    "data-name": "Path 35330",
    d: "M52.757,32.919l-1.255.074v3.469H50.1V27.9h1.4v3.912l1.255-.074,1.771-3.764h1.624l-2.14,4.281,2.214,4.281H54.6Z",
    transform: "translate(-13.124 -27.752)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35331",
    "data-name": "Path 35331",
    d: "M63.3,27.9h5.683v1.328L65,35.059v.221h3.985v1.181H63.374V35.133l3.985-5.83v-.221H63.374V27.9Z",
    transform: "translate(-16.582 -27.752)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33160",
    "data-name": "Group 33160",
    transform: "translate(37.271 0.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35332",
    "data-name": "Path 35332",
    d: "M64.571.374,55.345.3A1.827,1.827,0,0,0,53.5,2.145,1.827,1.827,0,0,0,55.345,3.99h7.38v7.38a1.827,1.827,0,0,0,1.845,1.845A2.122,2.122,0,0,0,65.9,12.7a2.2,2.2,0,0,0,.59-1.328l-.074-9.152A1.827,1.827,0,0,0,64.571.374Z",
    transform: "translate(-51.286 -0.3)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35333",
    "data-name": "Path 35333",
    d: "M57.733,8.6H52.345a1.845,1.845,0,1,0,0,3.69h3.543v3.543a1.827,1.827,0,0,0,1.845,1.845,2.122,2.122,0,0,0,1.328-.517,2.2,2.2,0,0,0,.59-1.328V10.445A1.94,1.94,0,0,0,57.733,8.6Z",
    transform: "translate(-50.5 -2.474)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33161",
    "data-name": "Group 33161",
    transform: "translate(0.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35334",
    "data-name": "Path 35334",
    d: "M6.326,6.421h3.912v6.938a37.911,37.911,0,0,1-4.576.443C1.307,13.8.2,11.366.2,6.864.2,2.066,1.6,0,5.588,0a28.555,28.555,0,0,1,4.65.517l-.074,2.066S7.8,2.362,6.03,2.362C3.669,2.362,3,3.174,3,6.938c0,3.543.517,4.576,2.952,4.576.812,0,1.624-.074,1.624-.074V8.856H6.326Z",
    transform: "translate(-0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35335",
    "data-name": "Path 35335",
    d: "M23.264,13.658H20.533V8.271L16.4.3h3.026l2.436,5.314L24.3.3h3.026L23.264,8.271v5.388Z",
    transform: "translate(-4.444 -0.079)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35336",
    "data-name": "Path 35336",
    d: "M33.2.3h9.816V2.662H39.473V13.585H36.743V2.736H33.2Z",
    transform: "translate(-8.845 -0.079)"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 35.043,
    transform: "translate(167.422 7.29)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33163",
    "data-name": "Group 33163",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3043",
    "data-name": "Group 3043",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3042",
    "data-name": "Group 3042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3040",
    "data-name": "Group 3040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M17.37,42.261,1.59,26.481A5.409,5.409,0,0,1,.006,22.908c-.008-.164-.008-.33,0-.5,0-.138.018-.276.036-.415a5.371,5.371,0,0,1,1.141-2.7c.038-.051.077-.1.117-.145l.745-.745a5.423,5.423,0,0,1,7.208.407L13.1,22.66,25.034,34.6a5.419,5.419,0,0,1-7.664,7.664ZM9.636,17.343a5.421,5.421,0,0,0-7.208-.407l-.744.744c.092-.107.189-.212.289-.312l.317-.317,6.886-6.886,8.577-8.577a5.419,5.419,0,1,1,7.665,7.664L13.48,21.188Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M8.491,20.662.777,12.947A2.646,2.646,0,0,1,0,11.2c0-.08,0-.161,0-.243s.009-.135.017-.2a2.637,2.637,0,0,1,.558-1.32.847.847,0,0,1,.058-.071L1,9a2.653,2.653,0,0,1,3.524.2l1.88,1.88,5.835,5.837a2.649,2.649,0,0,1-3.747,3.747ZM4.71,8.479a2.65,2.65,0,0,0-3.524-.2l-.364.363c.045-.053.092-.1.141-.153l.156-.155L4.485,4.97,8.678.777a2.649,2.649,0,1,1,3.747,3.747L6.59,10.358Z",
    transform: "translate(17.339 11.514)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4104",
    "data-name": "Path 4104",
    d: "M19.986-82H9.12V-61.53h3.99v-9.025h6.446v-3.438H13.11v-4.574h6.876Zm2.737-.038V-61.53h3.433V-82.043Zm6.845,7.221v8.134A5.024,5.024,0,0,0,31.2-62.6a7.638,7.638,0,0,0,4.819,1.5,7.638,7.638,0,0,0,4.819-1.5,5.024,5.024,0,0,0,1.627-4.083v-8.134H38.716V-67.3a2.988,2.988,0,0,1-.8,2.333,3.049,3.049,0,0,1-1.9.675,3.049,3.049,0,0,1-1.9-.675,2.988,2.988,0,0,1-.8-2.333v-7.521Zm22.776,3.192v-3.192H49.767v-4.543H46.022v4.543H44.548v3.192h1.473v10.1h3.745v-10.1Zm9.24,0v-3.192H59.006v-4.543H55.261v4.543H53.788v3.192h1.473v10.1h3.745v-10.1ZM73.157-65.8a3.427,3.427,0,0,1-3.1,1.75,3.164,3.164,0,0,1-2.671-1.259,3.922,3.922,0,0,1-.645-2.241h9.946v-.307a7.946,7.946,0,0,0-1.6-5.218A6.353,6.353,0,0,0,69.9-75.252a6.81,6.81,0,0,0-5,1.872,7.079,7.079,0,0,0-2.026,5.218,6.7,6.7,0,0,0,2.087,5.188,6.957,6.957,0,0,0,5.1,1.872A6.566,6.566,0,0,0,76.6-65.245Zm-6.293-4.144A3.128,3.128,0,0,1,70-72.612a3.13,3.13,0,0,1,3.162,2.671ZM79.573-61.53h3.745v-6.385a4.567,4.567,0,0,1,.737-2.947,3.06,3.06,0,0,1,2.486-1.074,2.815,2.815,0,0,1,1.75.491l.491-3.5a4.608,4.608,0,0,0-1.6-.307,4.073,4.073,0,0,0-2.21.583,4.483,4.483,0,0,0-1.658,1.842v-2H79.573ZM90.623-74.822V-61.53h3.745V-74.822Zm-.368-5.617A2.253,2.253,0,0,0,92.5-78.2a2.253,2.253,0,0,0,2.241-2.241A2.253,2.253,0,0,0,92.5-82.68,2.253,2.253,0,0,0,90.255-80.439Zm14.611,5.188a7.649,7.649,0,0,0-5.372,1.872,7,7,0,0,0-2.241,5.218,6.983,6.983,0,0,0,2.241,5.188,7.649,7.649,0,0,0,5.372,1.872,7.649,7.649,0,0,0,5.372-1.872,6.983,6.983,0,0,0,2.241-5.188,7,7,0,0,0-2.241-5.218A7.649,7.649,0,0,0,104.866-75.252Zm0,10.836a3.7,3.7,0,0,1-3.745-3.745,3.709,3.709,0,0,1,3.745-3.776,3.709,3.709,0,0,1,3.745,3.776A3.7,3.7,0,0,1,104.866-64.416Zm10.5,2.885h3.745v-6.784a4.574,4.574,0,0,1,.583-2.578,2.553,2.553,0,0,1,2.3-1.166,2.4,2.4,0,0,1,1.75.675,3.809,3.809,0,0,1,.706,2.609v7.244H128.2V-69.88a5.6,5.6,0,0,0-1.044-3.745,5.081,5.081,0,0,0-3.929-1.627,4.881,4.881,0,0,0-4.113,2.149v-1.719h-3.745Z",
    transform: "translate(29.228 95.052)",
    fill: "#212121"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/Logo3.91f8846649f7336561a2768444156264.svg";
export { ForwardRef as ReactComponent };